// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Tripway app-update notice — brand #d76420 / #713b14 */

.app-update-toast.Toastify__toast {
  background: transparent !important;
  box-shadow: none !important;
  padding: 0 !important;
  min-height: 0 !important;
  width: min(420px, calc(100vw - 24px));
  margin-bottom: 12px !important;
}

.app-update-toast .Toastify__toast-body {
  margin: 0 !important;
  padding: 0 !important;
}

.app-update-toast .Toastify__close-button {
  display: none !important;
}

.app-update-card {
  display: flex;
  align-items: flex-start;
  gap: 14px;
  padding: 16px 16px 14px;
  border-radius: var(--ds-radius-lg, 14px);
  background: var(--ds-card-bg, #fff);
  border: 1px solid color-mix(in srgb, var(--ds-accent, #d76420) 28%, var(--ds-border, #e2e8f0));
  box-shadow:
    0 10px 30px rgba(113, 59, 20, 0.14),
    0 2px 8px rgba(15, 23, 42, 0.06);
  position: relative;
  overflow: hidden;
  animation: app-update-in 0.35s ease both;
}

.app-update-card::before {
  content: "";
  position: absolute;
  inset-block: 0;
  inset-inline-start: 0;
  width: 4px;
  background: linear-gradient(180deg, #e8842e 0%, #d76420 55%, #713b14 100%);
}

.app-update-card__icon {
  flex-shrink: 0;
  width: 42px;
  height: 42px;
  border-radius: 12px;
  display: grid;
  place-items: center;
  color: #fff;
  background: linear-gradient(145deg, #e8842e 0%, #d76420 48%, #713b14 100%);
  box-shadow: 0 6px 14px rgba(215, 100, 32, 0.35);
}

.app-update-card__icon svg {
  width: 20px;
  height: 20px;
}

.app-update-card__body {
  flex: 1 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.app-update-card__eyebrow {
  margin: 0;
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  color: var(--ds-accent, #d76420);
}

.app-update-card__title {
  margin: 0;
  font-size: 14.5px;
  font-weight: 700;
  line-height: 1.45;
  color: #1e293b;
}

.app-update-card__hint {
  margin: 0;
  font-size: 12.5px;
  line-height: 1.5;
  color: var(--ds-muted, #64748b);
}

.app-update-card__actions {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 8px;
  margin-top: 10px;
}

.app-update-card__btn {
  border: none;
  border-radius: 999px;
  padding: 8px 16px;
  font-size: 13px;
  font-weight: 700;
  cursor: pointer;
  transition: transform 0.15s ease, box-shadow 0.15s ease, filter 0.15s ease;
}

.app-update-card__btn:active {
  transform: translateY(1px);
}

.app-update-card__btn--primary {
  color: #fff;
  background: linear-gradient(135deg, #e8842e 0%, #d76420 50%, #713b14 100%);
  box-shadow: 0 6px 14px rgba(215, 100, 32, 0.32);
}

.app-update-card__btn--primary:hover {
  filter: brightness(1.05);
  box-shadow: 0 8px 18px rgba(215, 100, 32, 0.4);
}

.app-update-card__btn--ghost {
  background: transparent;
  color: var(--ds-muted, #64748b);
  padding-inline: 10px;
}

.app-update-card__btn--ghost:hover {
  color: #713b14;
  background: var(--ds-accent-soft, rgba(215, 100, 32, 0.1));
}

body.dark-theme .app-update-card {
  background: var(--ds-card-bg, #1e293b);
  border-color: color-mix(in srgb, #d76420 35%, #334155);
  box-shadow:
    0 12px 32px rgba(0, 0, 0, 0.45),
    0 2px 8px rgba(0, 0, 0, 0.25);
}

body.dark-theme .app-update-card__title {
  color: #f8fafc;
}

body.dark-theme .app-update-card__hint {
  color: #94a3b8;
}

body.dark-theme .app-update-card__btn--ghost:hover {
  color: #f8fafc;
}

@keyframes app-update-in {
  from {
    opacity: 0;
    transform: translateY(-10px) scale(0.98);
  }
  to {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
}

@media (max-width: 480px) {
  .app-update-card {
    gap: 12px;
    padding: 14px;
  }

  .app-update-card__actions {
    flex-direction: column-reverse;
    align-items: stretch;
  }

  .app-update-card__btn {
    width: 100%;
    text-align: center;
  }
}
`, "",{"version":3,"sources":["webpack://./src/styles/appUpdateNotice.css"],"names":[],"mappings":"AAAA,wDAAwD;;AAExD;EACE,kCAAkC;EAClC,2BAA2B;EAC3B,qBAAqB;EACrB,wBAAwB;EACxB,qCAAqC;EACrC,8BAA8B;AAChC;;AAEA;EACE,oBAAoB;EACpB,qBAAqB;AACvB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,uBAAuB;EACvB,wCAAwC;EACxC,mCAAmC;EACnC,8FAA8F;EAC9F;;oCAEkC;EAClC,kBAAkB;EAClB,gBAAgB;EAChB,wCAAwC;AAC1C;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,cAAc;EACd,qBAAqB;EACrB,UAAU;EACV,0EAA0E;AAC5E;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,0EAA0E;EAC1E,+CAA+C;AACjD;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,gCAAgC;AAClC;;AAEA;EACE,SAAS;EACT,iBAAiB;EACjB,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,iBAAiB;EACjB,gBAAgB;EAChB,+BAA+B;AACjC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,QAAQ;EACR,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,oBAAoB;EACpB,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,0EAA0E;AAC5E;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,WAAW;EACX,0EAA0E;EAC1E,+CAA+C;AACjD;;AAEA;EACE,wBAAwB;EACxB,8CAA8C;AAChD;;AAEA;EACE,uBAAuB;EACvB,+BAA+B;EAC/B,oBAAoB;AACtB;;AAEA;EACE,cAAc;EACd,0DAA0D;AAC5D;;AAEA;EACE,sCAAsC;EACtC,sDAAsD;EACtD;;iCAE+B;AACjC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE;IACE,UAAU;IACV,wCAAwC;EAC1C;EACA;IACE,UAAU;IACV,iCAAiC;EACnC;AACF;;AAEA;EACE;IACE,SAAS;IACT,aAAa;EACf;;EAEA;IACE,8BAA8B;IAC9B,oBAAoB;EACtB;;EAEA;IACE,WAAW;IACX,kBAAkB;EACpB;AACF","sourcesContent":["/* Tripway app-update notice — brand #d76420 / #713b14 */\n\n.app-update-toast.Toastify__toast {\n  background: transparent !important;\n  box-shadow: none !important;\n  padding: 0 !important;\n  min-height: 0 !important;\n  width: min(420px, calc(100vw - 24px));\n  margin-bottom: 12px !important;\n}\n\n.app-update-toast .Toastify__toast-body {\n  margin: 0 !important;\n  padding: 0 !important;\n}\n\n.app-update-toast .Toastify__close-button {\n  display: none !important;\n}\n\n.app-update-card {\n  display: flex;\n  align-items: flex-start;\n  gap: 14px;\n  padding: 16px 16px 14px;\n  border-radius: var(--ds-radius-lg, 14px);\n  background: var(--ds-card-bg, #fff);\n  border: 1px solid color-mix(in srgb, var(--ds-accent, #d76420) 28%, var(--ds-border, #e2e8f0));\n  box-shadow:\n    0 10px 30px rgba(113, 59, 20, 0.14),\n    0 2px 8px rgba(15, 23, 42, 0.06);\n  position: relative;\n  overflow: hidden;\n  animation: app-update-in 0.35s ease both;\n}\n\n.app-update-card::before {\n  content: \"\";\n  position: absolute;\n  inset-block: 0;\n  inset-inline-start: 0;\n  width: 4px;\n  background: linear-gradient(180deg, #e8842e 0%, #d76420 55%, #713b14 100%);\n}\n\n.app-update-card__icon {\n  flex-shrink: 0;\n  width: 42px;\n  height: 42px;\n  border-radius: 12px;\n  display: grid;\n  place-items: center;\n  color: #fff;\n  background: linear-gradient(145deg, #e8842e 0%, #d76420 48%, #713b14 100%);\n  box-shadow: 0 6px 14px rgba(215, 100, 32, 0.35);\n}\n\n.app-update-card__icon svg {\n  width: 20px;\n  height: 20px;\n}\n\n.app-update-card__body {\n  flex: 1;\n  min-width: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n}\n\n.app-update-card__eyebrow {\n  margin: 0;\n  font-size: 11px;\n  font-weight: 700;\n  letter-spacing: 0.04em;\n  text-transform: uppercase;\n  color: var(--ds-accent, #d76420);\n}\n\n.app-update-card__title {\n  margin: 0;\n  font-size: 14.5px;\n  font-weight: 700;\n  line-height: 1.45;\n  color: #1e293b;\n}\n\n.app-update-card__hint {\n  margin: 0;\n  font-size: 12.5px;\n  line-height: 1.5;\n  color: var(--ds-muted, #64748b);\n}\n\n.app-update-card__actions {\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n  gap: 8px;\n  margin-top: 10px;\n}\n\n.app-update-card__btn {\n  border: none;\n  border-radius: 999px;\n  padding: 8px 16px;\n  font-size: 13px;\n  font-weight: 700;\n  cursor: pointer;\n  transition: transform 0.15s ease, box-shadow 0.15s ease, filter 0.15s ease;\n}\n\n.app-update-card__btn:active {\n  transform: translateY(1px);\n}\n\n.app-update-card__btn--primary {\n  color: #fff;\n  background: linear-gradient(135deg, #e8842e 0%, #d76420 50%, #713b14 100%);\n  box-shadow: 0 6px 14px rgba(215, 100, 32, 0.32);\n}\n\n.app-update-card__btn--primary:hover {\n  filter: brightness(1.05);\n  box-shadow: 0 8px 18px rgba(215, 100, 32, 0.4);\n}\n\n.app-update-card__btn--ghost {\n  background: transparent;\n  color: var(--ds-muted, #64748b);\n  padding-inline: 10px;\n}\n\n.app-update-card__btn--ghost:hover {\n  color: #713b14;\n  background: var(--ds-accent-soft, rgba(215, 100, 32, 0.1));\n}\n\nbody.dark-theme .app-update-card {\n  background: var(--ds-card-bg, #1e293b);\n  border-color: color-mix(in srgb, #d76420 35%, #334155);\n  box-shadow:\n    0 12px 32px rgba(0, 0, 0, 0.45),\n    0 2px 8px rgba(0, 0, 0, 0.25);\n}\n\nbody.dark-theme .app-update-card__title {\n  color: #f8fafc;\n}\n\nbody.dark-theme .app-update-card__hint {\n  color: #94a3b8;\n}\n\nbody.dark-theme .app-update-card__btn--ghost:hover {\n  color: #f8fafc;\n}\n\n@keyframes app-update-in {\n  from {\n    opacity: 0;\n    transform: translateY(-10px) scale(0.98);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0) scale(1);\n  }\n}\n\n@media (max-width: 480px) {\n  .app-update-card {\n    gap: 12px;\n    padding: 14px;\n  }\n\n  .app-update-card__actions {\n    flex-direction: column-reverse;\n    align-items: stretch;\n  }\n\n  .app-update-card__btn {\n    width: 100%;\n    text-align: center;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
